// app/models/application_domain.rb
// Please Update the default on main domain

import { BrokerConfigs } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

export enum PARTNER_NAME {
  STOCKWIZ = 'stockwiz',
  ALGOVERSE = 'algoverse',
  QUBIT = 'qubit',
};

type availableQuantConfigOrderTypes = 'market' | 'limit' | 'sl-m';

export type QuantConfigOrderTypes = Record<
  availableQuantConfigOrderTypes,
  { label: string; value: availableQuantConfigOrderTypes }
>;

export type RenameProductType = {
  mis: string;
  nrml: string;
};

export enum AVAILABLE_ORDER_TYPE  {
  AUTOMATIC = 'automatic',
  PAPER = 'paper',
  ONECLICK = 'oneclick'
};

export type UiContent = {
  should_enable_bse: boolean;
  logoImage: string;
  favicon: string;
  logoText: string;
  welcomeText?: string;
  allowed_quant_config_ordertypes?: Array<availableQuantConfigOrderTypes>;
  allowed_order_type?: AVAILABLE_ORDER_TYPE;
  rename_menu?: {
    create_strategy: string;
    marketplace: string;
    product_type: RenameProductType;
  };
  show_plan_page: boolean;
  should_show_backtest_in_strategy?: boolean;
  faq_url?: string;
};

export type ApplicationDomain = {
  id?: string;
  navbar: string;
  host: string;
  breadcrumb: string;
  dashboard: string;
  config: {
    partner_profile?: {
      name: PARTNER_NAME;
      admin_user_ids: Array<string | number>;
      admin_pages: string[];
      owner_share_percentage: number;
      has_own_api_credentials: boolean;
      broker_credentials: {
        [key in PARTNER_NAME]?: {
          partner_id: string;
          secret_key?: string;
        };
      };
    };
    brokers: string[];
    ui_content: UiContent;
    brokerConfigs: BrokerConfigs;
    addon_max_live_runs: number;
    add_free_b2b_plan: boolean;
    free_trial_days: number;
    free_trial_by_coupon: boolean;
    advance_builder_allowed: boolean;
    allow_manual_signals: boolean;
    free_strategy_access_by_coupon_purchase: boolean;
  };
};
